/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type WebOrderMutationVariables = Types.Exact<{
  input: Types.WebOrderInput;
}>;

export type WebOrderMutation = {
  __typename?: 'Mutation';
  results?: {
    __typename?: 'PurchaseWebOrder';
    success?: {
      __typename?: 'PurchaseWebOrderSuccess';
      purchaseId: string;
      contract: {
        __typename?: 'PurchaseWebContract';
        id: string;
        orderType: Types.PurchaseOrderType;
        initialDuration: number;
        renewalDuration: number;
        featureSet: string;
        campaignIdentifier: string;
        duration: number;
        price: {
          __typename?: 'PurchaseWebPrice';
          initial: number;
          renewal: number;
          currency: Types.PurchaseWebCurrency;
          current?: number | null;
        };
      };
    } | null;
    error?: { __typename?: 'PurchaseWebOrderError'; message: string } | null;
  } | null;
};

export const WebOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'WebOrderInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'purchaseWebOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'success' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'purchaseId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contract' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'WebContract' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebPrice' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PurchaseWebPrice' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'initial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renewal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'current' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebContract' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PurchaseWebContract' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renewalDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureSet' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignIdentifier' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'price' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'WebPrice' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WebOrderMutation, WebOrderMutationVariables>;
